export const routes = [
  { path: "/", breadcrumb: "Dashboard" },
  { path: "/home", breadcrumb: "Home" },
  { path: "/my-classes", breadcrumb: "My Classes" },
  { path: "/create-child", breadcrumb: "Add New Child Account" },
  { path: "/manage-child", breadcrumb: "Manage Children Accounts" },
  { path: "/tasks", breadcrumb: "My Tasks" },
  { path: "/timetable", breadcrumb: "My Timetable" },
  { path: "/enroll", breadcrumb: "Join a Class" },
  { path: "/success", breadcrumb: "Subscription Successful" },
  { path: "/enroll/confirm-enrollment", breadcrumb: "Confirm Group Classes" },
  { path: "/enroll/confirm-private-enrollment", breadcrumb: "Confirm Private Classes" },
  { path: "/my-profile", breadcrumb: "My Profile" },
  { path: "/subscriptions", breadcrumb: "My Subscriptions" },
];